export enum FacilityBillingRateType {
    day = 0,
    mid = 1,
    night = 2,
    weekendDay = 3,
    weekendMid = 4,
    weekendNight = 5
}
